import React, { createContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import Sidenav from '../../atoms/Sidenav';
import WarningMessage from '../../atoms/WarningMessage';
import AdminMenu from './MenuJSON/adminMenu.json';
import ApprovedCustomerMenu from './MenuJSON/customerMenu.json';
import PendingCustomerMenu from './MenuJSON/newCustomerMenu.json';
import { PendingCustomerMessage } from '../../utilities/constants';
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import { getUserData } from '../../utilities/app';

export const BreadcrumbContext = createContext([
  {
    "linkText": "Home",
    "path": "/home"
  }
]);

function Layout() {
  const navigate = useNavigate();
  const customer = useSelector(state => state.customer.selectedCustomer);
  const [currentBreadcrumb, setCurrentBreadcrumb] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { userType, verificatioN_CODE, status } = getUserData();
  const isDashboardPage = window.location.pathname.toLowerCase().includes('dashboard');
  useEffect(() => {
    !userType && navigate('/signin');
  }, [userType]);

  const getMenuJson = () => {
    return userType === 'customer' ? (
        status == 1 ? ApprovedCustomerMenu : PendingCustomerMenu
    ) : AdminMenu;
  }

  useEffect(() => {
    const menuItemsFromJson = getMenuJson();
    if (customer && userType !== 'admin') {
      setMenuItems(menuItemsFromJson.map(item => {
        if (item.submenu) {
          return {
            ...item,
            submenu: item.submenu.filter(sub => 
              !(!customer.isNewBookIntegration && sub.name === "- All Bookings")
            )
          };
        }
        return item;
      }));
    }
    else {
      setMenuItems(menuItemsFromJson);
    }
  }, [customer]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <BreadcrumbContext.Provider value={{currentBreadcrumb, setCurrentBreadcrumb}}>
      <div className='layout'>
        <div className='layout-header'>
          <Header
            isSidebarOpen={isSidebarOpen}
            onToggleSidebar={toggleSidebar}
          />
        </div>
        <div className='layout-page'>
          <div className={`layout-sidenav ${isSidebarOpen ? 'layout-sidenav-open' : ''}`}>
            <Sidenav
              menus = { menuItems }
              onNavigate={closeSidebar}
            />
          </div>
          <button
            className={`layout-overlay ${isSidebarOpen ? 'layout-overlay-visible' : ''}`}
            type='button'
            aria-label='Close sidebar'
            onClick={closeSidebar}
          />
          <div className='layout-content'>
            {isDashboardPage ? (
              !status ? <WarningMessage msg={verificatioN_CODE || PendingCustomerMessage}/> : verificatioN_CODE ? <WarningMessage msg={verificatioN_CODE}/> : null
            ) : null}
            <Outlet />
          </div>
        </div>
      </div>
    </BreadcrumbContext.Provider>
  );
}

export default Layout;
